module.exports = __webpack_public_path__ + "media/images/icons/phone--stroke-78c5b214d2a38ab7a627f0b5372cee9d.svg";